export default function sliceMonthName(name){
    return name.substr(0, 3)
}